/**
 * THIS FILE IS DEPRECATED - DO NOT ADD ANYTHING ELSE
 *
 * @todo Remove this file during the staged user enhancements epic
 * @see https://jumpcloud.atlassian.net/browse/DE-2363
 */
import { get } from 'lodash';
import { mapGetters } from 'vuex';
import { userStateActionType } from 'client/systemusers/constants/SystemUserConstants';

// This code should be examined to see if we can make it more efficient
// @see https://jumpcloud.atlassian.net/browse/DE-2356
export default {
  computed: {
    ...mapGetters('SystemUserCollection', {
      getDisplayName: 'getDisplayName',
      getStagedUsers: 'getStagedUsers',
      selectedItems: 'getSelectedItems',
      usersIneligibleForActivation: 'getUsersIneligibleForActivation',
      usersIneligibleForSuspension: 'getUsersIneligibleForSuspension',
    }),

    /**
     * If the action is suspend, samba users, and suspended users are ineligible
     * If the action is activate, active users are ineligible
     */
    ineligibleCount() {
      const { activate, suspend } = userStateActionType;
      let count = 0;

      if (!this.item && this.action === suspend) {
        const {
          sambaServiceUsers,
          suspendedUsers,
        } = this.usersIneligibleForSuspension;

        // @todo Edge Case - filter out samba user from suspendedUsers in case the samba
        // user is suspended; otherwise you get an `off by one error`
        const filteredUsers = suspendedUsers
          .filter(user => user.samba_service_user !== true);

        count = sambaServiceUsers.length + filteredUsers.length;
      }

      if (!this.item && (this.action === activate)) {
        count = this.usersIneligibleForActivation.activatedUsers.length;
      }

      // If this is the aside, the samba user is ineligible for suspension
      if (this.isSambaUser && this.action === suspend) {
        count = 1;
      }

      return count;
    },

    isSambaUser() {
      return get(this.item, 'samba_service_user', false);
    },

    sambaUserText() {
      const { suspend } = userStateActionType;
      let name = '';
      let sambaWarning = '';

      const { sambaServiceUsers } = this.usersIneligibleForSuspension;

      // Samba users can be activated but not suspended
      if (this.action === suspend) {
        if (!this.item && sambaServiceUsers.length) {
          const sambaServiceUser = sambaServiceUsers[0];
          name = this.getDisplayName(sambaServiceUser);
        } else if (this.isSambaUser) {
          name = this.getDisplayName(this.item);
        }

        if (name) {
          sambaWarning = `*${name}* is the active Samba Service Account. To suspend this user, you must designate another Samba Service Account or disable Samba Authentication in the JumpCloud LDAP Configuration.`;
        }
      }

      return sambaWarning;
    },

    stagedPendingPasswordCount() {
      return this.getStagedUsers.stagedPendingPassword.length;
    },

    stagedWithPasswordCount() {
      return this.getStagedUsers.stagedWithPassword.length;
    },

    suspendedCount() {
      const {
        suspendedUsers,
      } = this.usersIneligibleForSuspension;
      return suspendedUsers.length ? suspendedUsers.length : 0;
    },

    suspendedWithPasswordCount() {
      const {
        suspendedUsers,
      } = this.usersIneligibleForSuspension;
      return suspendedUsers.filter(
        item => (item.activated && !item.account_locked && !item.password_expired),
      ).length;
    },
  },
};
